// import 'animate.css';
import ReactDOM from 'react-dom';
// 接口-校验域名和获取配置
import ChatMain from '@/pages/chatMain';
import { getConfig, getGuideQuestion, validateDomain } from '@/utils/api';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import VConsole from 'vconsole';
// const vConsole = new VConsole();
window.forNativeVideoStatus = false; //视频状态
window.unReadMesaggeCount = {
  count: 0,
};
// let chatHistoryVersion = localStorage.getItem('chatHistoryVersion');
// let historySession = localStorage.getItem('historySession');
// if (!chatHistoryVersion && historySession) {
//   // 清空localstorage
//   localStorage.clear();
//   localStorage.setItem('chatHistoryVersion', '1.0.0');
//   setTimeout(() => {
//     window.location.reload();
//   }, 200);
// }
//获取inprogress缓存值如果channel为CONNECT或者messageDataId为空则清空inprogress缓存值，重新开启会话避免singleChat白屏问题
let inProgress = JSON.parse(localStorage.getItem('inProgress')) || {};
if (inProgress && (inProgress.channel == 'CONNECT' || !inProgress.messageDataId || inProgress.messageDataId == '')) {
  localStorage.removeItem('inProgress');
}

// 立即执行函数
(async function () {
  try {
    loadChatCss();
    // 获取Chat入参信息
    let entryParam = window['goclouds']?.ac[0][0];
    if (!entryParam) {
      entryParam = window['connectnow']?.ac[0][0];
    }
    // entryParam = {
    //   // 公司id
    //   v: 'd6ff59a027861d7d4133e1d6b6872464',
    //   // 获取Amazon Connect实例信息
    //   i: '',
    //   // 客户名称
    //   un: '',
    //   // 客户邮箱
    //   ue: '',
    //   // 客户Id menberId
    //   m: '',
    //   // 客户手机号
    //   um: '',
    //   channelType: '8',
    //   fullScreen: false,
    //   // showToAgentName: true,
    //   // faqUseDeviceLanguage: true,
    //   useNewMobileChat: true,
    //   // mobileIconPosition: {
    //   //   bottom: '30px',
    //   //   right: '50px',
    //   //   top: 'auto',
    //   //   left: 'auto',
    //   // },
    //   singleChat: true,
    //   // zIndex: '1000',
    //   // needInfoCollection: true,
    //   // enableConfigTool: true,
    //   // isDebuggerMode: true,
    //   // chatWindowTriggerIcon: 'https://pic.qqans.com/up/2022-10/202210271112567270.png',
    // };
    if (entryParam?.isDebuggerMode) {
      new VConsole();
    }
    if (entryParam?.enableConfigTool) {
      entryParam = { v: entryParam.v, enableConfigTool: true, ...JSON.parse(localStorage.getItem('configTool')) };
    }
    let companyId = entryParam.v;
    let channelType = entryParam.channelType;
    let instanceId = '';
    let username = entryParam.un;
    let userEmail = entryParam.ue;
    let memberId = entryParam.m;
    let userMobile = entryParam.um;
    let country = entryParam.country;
    let containerW = entryParam.w;
    let containerH = entryParam.h;
    let fullScreen = entryParam.fullScreen; //控制是否全屏显示
    let singleChat = entryParam.singleChat; //是否多个会话
    let chatWindowTriggerIcon = entryParam.chatWindowTriggerIcon; //聊天窗口触发图标
    let showEndCustomerName = entryParam.showEndCustomerName; // 是否显示终端用户名称
    let showOnlineMediaForVIP = entryParam.showOnlineMediaForVIP; // 是否显示在线语音和视频
    let noHeader = entryParam.noHeader; //是否显示头部,建议和singlechat一同使用
    let mobileEnterSendMessage = entryParam.mobileEnterSendMessage; //手机端控制回车发送
    let useNewMobileChat = entryParam.useNewMobileChat; //是否使用新版移动端聊天
    let mobileIconPosition = entryParam.mobileIconPosition; //移动端图标位置
    let showToAgentName = entryParam.showToAgentName; // 是否显示转人工按钮文字
    let pcIconPosition = entryParam.pcIconPosition; // 网页端图标位置
    let ticketAttr = entryParam.ticketAttr || {}; //客户自定义入参
    let ticketObj = {};
    let languageCode = entryParam.languageCode; // 接收客户传入的语言参数。
    let faqUseDeviceLanguage = entryParam.faqUseDeviceLanguage; // 是否使用设备语言
    let enableConfigTool = entryParam.enableConfigTool; // 是否启用配置工具
    let needInfoCollection = entryParam.needInfoCollection; // 是否需要收集信息
    let zIndex = entryParam.zIndex; // 聊天窗口zIndex

    // 循环ticketAttr
    if (Object.keys(ticketAttr).length !== 0) {
      for (let key in ticketAttr) {
        ticketObj['extended_' + key] = ticketAttr[key];
      }
    }

    // let noIcon = entryParam.noIcon; //控制是否显示客服图标
    if (!entryParam.v) {
      console.log('缺少公司信息，请检查配置或联系管理员');
      return;
    }
    const device = getDevice();
    if (!entryParam.channelType) {
      console.log('缺少渠道类型信息');
      channelType = '8';
    }
    //增加判断强制渠道按照web与app端配置，如果是语音渠道则不进行判断
    // if (device === 'mobile' && channelType == '8') {
    //   console.error('渠道未配置，请联系系统管理员');
    //   return;
    // }
    // if (device === 'pc' && channelType == '9') {
    //   console.error('渠道未配置，请联系系统管理员');
    //   return;
    // }

    // 获取网站信息
    let domain = document.domain;
    // let domain = 'localhost';
    // let domain = 'dev.connectnowai.com'; //生产地址

    let language = languageCode || navigator.language || 'zh';
    // 如果客户传入的语言code不为空则使用
    // if (languageCode) {
    //   language = languageCode;
    // }
    console.log('entryParam', entryParam);

    // 查询是否存在在白名单中
    const validateResult = await validateDomain({ domain: domain, companyId: companyId });
    if (!validateResult.data) {
      console.error('域名未在白名单中，请联系系统管理员');
      return;
    }

    // 设备类型，mobile/pc
    let params = {
      companyId: companyId,
      // instanceId: instanceId || '',
      language: language,
      domain: domain,
      // domain: 'test.connectnowai.com',
      channelType: channelType,
    };
    // console.log('getConfig - params', params);
    //获取此实例的配置信息。
    const configResult = await getConfig(params);
    if (configResult.code !== 200) {
      return;
    }
    let data = configResult.data;
    // console.log('data>>>>>', data);
    data.companyId = companyId;
    instanceId = data.connectInstanceId;
    entryParam.instanceId = instanceId;
    // 判断是否传递用户联系信息
    if (username || userEmail || userMobile) {
      let contactInfo = {
        username: username,
        userEmail: userEmail,
        phoneNumber: userMobile,
      };
      localStorage.setItem('goclouds-chat-form', JSON.stringify(contactInfo));
    }

    // 处理本地数据
    const localForm = JSON.parse(window.localStorage.getItem('goclouds-chat-form'));
    if (localForm !== null) {
      entryParam.un = username || localForm.username;
      entryParam.ue = userEmail || localForm.userEmail;
      entryParam.m = memberId || localForm.memberId;
      entryParam.um = userMobile || localForm.userMobile;
      entryParam.localForm = true;
    }
    let options = buildChatClientOptions(data, entryParam);

    try {
      if (options.documentKnowledgeBaseId) {
        let questionResult = await getGuideQuestion({
          companyId: companyId,
          knowledgeId: options.documentKnowledgeBaseId,
        });
        if (questionResult.code !== 200) {
          return;
        }
        options.guideQuestion = questionResult.data;
      }
      if (country) {
        options.extendedCountry = country;
      }
      options.channelType = channelType;
      options.containerW = containerW;
      options.containerH = containerH;
      options.isVideoContainer = channelType == 10 || channelType == 11 || channelType == 17 || channelType == 18;
      options.fullScreen = fullScreen ? fullScreen : false;
      options.singleChat = singleChat ? singleChat : false;
      options.chatWindowTriggerIcon = chatWindowTriggerIcon;
      options.needInfoCollection = needInfoCollection ? needInfoCollection : false;
      options.zIndex = zIndex ? zIndex : '';
      options.mobileEnterSendMessage = mobileEnterSendMessage ? languageCode : true;
      options.showEndCustomerName = showEndCustomerName ? showEndCustomerName : false;
      options.showOnlineMediaForVIP = typeof showOnlineMediaForVIP === 'boolean' ? showOnlineMediaForVIP : true;
      options.noHeader = noHeader ? noHeader : false;
      options.ticketAttr = ticketObj;
      options.language = language;
      options.useNewMobileChat = useNewMobileChat ? useNewMobileChat : false;
      options.faqUseDeviceLanguage = faqUseDeviceLanguage ? faqUseDeviceLanguage : false;
      options.mobileIconPosition = mobileIconPosition
        ? mobileIconPosition
        : {
            bottom: '30px',
            right: '50px',
            top: 'auto',
            left: 'auto',
          };
      options.pcIconPosition = pcIconPosition
        ? pcIconPosition
        : {
            bottom: '30',
            right: '50',
            top: 'auto',
            left: 'auto',
          };
      options.enableConfigTool = enableConfigTool ? enableConfigTool : false;
      options.showToAgentName = showToAgentName;
    } catch (e) {}

    // 为德业公司增加新字段“xx-xx点固定时间不可转人工”兼容多个国家语言
    let nonWorkingHours = '';
    switch (options.language) {
      case 'zh':
      case 'zh-CN':
        nonWorkingHours =
          '人工客服在线时间(UTC+8):周一到周五 8:30-20:30;周六周日以及节假日 8:30-17:00.请留言或发送邮件到客服邮箱，我们将尽快解答您的疑惑。';
        break;
      case 'en':
      case 'en-US': // 英语
        nonWorkingHours =
          'Customer service online hours (UTC+8): Monday to Friday 8:30 AM - 20:30 PM; Weekends & Holidays 8:30 AM - 17:00 PM. Please leave your message or send us an Email. We will get back to you asap.';
        break;
      case 'de':
      case 'de-DE': // 德语
        nonWorkingHours =
          'Online-Kundendienstzeiten (UTC+8): Montag bis Freitag 8:30 - 20:30 Uhr; Wochenenden & Feiertage 8:30 - 17:00 Uhr. Bitte hinterlassen Sie eine Nachricht oder senden Sie uns eine E-Mail. Wir melden uns so schnell wie möglich bei Ihnen.';
        break;
      case 'es':
      case 'es-ES': // 西班牙语
        nonWorkingHours =
          'Horario de atención al cliente en línea (UTC+8): De lunes a viernes de 8:30 a.m. a 8:30 p.m.; Fines de semana y festivos de 8:30 a.m. a 5:00 p.m. Por favor, deje su mensaje o envíenos un correo electrónico. Nos pondremos en contacto con usted lo antes posible.';
        break;
      case 'it':
      case 'it-IT': // 意大利语
        nonWorkingHours =
          "Orari di servizio clienti online (UTC+8): dal lunedì al venerdì dalle 8:30 alle 20:30; weekend e festivi dalle 8:30 alle 17:00. Lascia un messaggio o inviaci un'email. Ti risponderemo al più presto.";
        break;
      case 'ja':
      case 'ja-JP': // 日语
        nonWorkingHours =
          'オンラインカスタマーサービス時間(UTC+8)：月曜日から金曜日の午前8時30分から午後8時30分まで、週末および祝日は午前8時30分から午後5時まで。メッセージを残すか、メールを送信してください。できるだけ早く返信いたします。';
        break;
      case 'pl':
      case 'pl-PL': // 波兰语
        nonWorkingHours =
          'Godziny obsługi klienta online (UTC+8): od poniedziałku do piątku 8:30 - 20:30; weekendy i święta 8:30 - 17:00. Proszę zostawić wiadomość lub wysłać do nas e-mail. Odpowiemy tak szybko, jak to możliwe.';
        break;
      case 'pt':
      case 'pt-Pt': // 葡萄牙语
        nonWorkingHours =
          'Horário de atendimento online ao cliente (UTC+8): Segunda a Sexta-feira, das 8h30 às 20h30; Fins de semana e feriados, das 8h30 às 17h. Por favor, deixe sua mensagem ou envie-nos um e-mail. Retornaremos o mais breve possível.';
        break;
      case 'uk':
      case 'uk-UA': // 乌克兰语
        nonWorkingHours =
          "Години роботи онлайн-служби підтримки клієнтів (UTC+8): з понеділка по п'ятницю з 8:30 до 20:30; вихідні та святкові дні з 8:30 до 17:00. Залиште своє повідомлення або надішліть нам електронного листа. Ми зв'яжемося з вами якнайшвидше.";
        break;
      case 'fr':
      case 'fr-FR': // 法语
        nonWorkingHours =
          "Heures d'ouverture du service client en ligne (UTC+8) : Du lundi au vendredi de 8h30 à 20h30 ; Week-ends et jours fériés de 8h30 à 17h. Veuillez laisser un message ou nous envoyer un e-mail. Nous vous répondrons dès que possible.";
        break;
      case 'th':
      case 'th-TH': // 泰语
        nonWorkingHours =
          'เวลาทำการบริการลูกค้าออนไลน์ (UTC+8): วันจันทร์ถึงวันศุกร์ 8.30 น. - 20.30 น. วันหยุดสุดสัปดาห์และวันหยุด 8.30 น. - 17.00 น. กรุณาเว้นข้อความหรือส่งอีเมลถึงเรา เราจะตอบกลับโดยเร็วที่สุด';
        break;
      case 'id':
      case 'id-ID': // 印尼语
        nonWorkingHours =
          'Jam layanan pelanggan online (UTC+8): Senin hingga Jumat 8:30 AM - 20:30 PM; Akhir pekan & Hari Libur 8:30 AM - 17:00 PM. Silakan tinggalkan pesan Anda atau kirimkan email kepada kami. Kami akan segera menghubungi Anda.';
        break;
      case 'vi':
      case 'vi-VN': // 越南语
        nonWorkingHours =
          'Giờ làm việc dịch vụ khách hàng trực tuyến (UTC+8): Thứ Hai đến Thứ Sáu 8:30 Sáng - 20:30 Tối; Cuối tuần & Ngày lễ 8:30 Sáng - 17:00 Chiều. Vui lòng để lại tin nhắn hoặc gửi email cho chúng tôi. Chúng tôi sẽ phản hồi bạn sớm nhất có thể.';
        break;
      case 'tl':
      case 'tl-PH': // 菲律宾语
        nonWorkingHours =
          'Online Customer Service Hours (UTC+8): Lunes hanggang Biyernes 8:30 AM - 8:30 PM; Kapihan at Pista Opisyal 8:30 AM - 5:00 PM. Mangyaring iwan ng mensahe o magpadala sa amin ng Email. Makikipag-ugnayan kami sa iyo sa lalong madaling panahon.';
        break;
    }
    options.nonWorkingHours = nonWorkingHours;
    const fpPromise = FingerprintJS.load();
    let localFingerprintId = localStorage.getItem('fingerprintId');
    if (localFingerprintId) {
      options.fingerprintId = localFingerprintId;
    } else {
      await fpPromise.then((fp) => {
        fp.get().then((result) => {
          options.fingerprintId = result.visitorId;
          localStorage.setItem('fingerprintId', result.visitorId);
        });
      });
    }
    console.log('options', options);
    const livechatDiv = document.getElementById('ConnectNowChat');
    if (!livechatDiv) {
      const containerId = 'ConnectNowChat';
      createDomNode(containerId);
      // 加载客户端...
      ReactDOM.render(<ChatMain config={options} device={device} />, document.getElementById(containerId));
      // 如果options.zIndex不为空，设置position和z-index
      if (options.zIndex) {
        const containerDiv = document.getElementById(containerId);
        if (containerDiv) {
          containerDiv.style.position = 'fixed';
          containerDiv.style.zIndex = options.zIndex;
        }
      }
    } else {
      // 如果div已存在，也需要设置样式
      if (options.zIndex) {
        livechatDiv.style.position = 'fixed';
        livechatDiv.style.zIndex = options.zIndex;
      }
    }
  } catch (e) {
    console.error('exception log', e);
  }
})();

/**
 * 构建Chat客户端配置数据
 *
 * @param configData 接口返回的Chat配置数据
 * @param username 客户名称
 * @returns Object Chat客户端所需数据
 */
function buildChatClientOptions(configData, entryParams) {
  if (configData === null) {
    return null;
  }
  // let name = username || '客户' + Math.floor(Math.random() * 10000);

  let options = {
    channelId: configData.channelId,
    companyId: configData.companyId,
    username: entryParams.un, // 客户名称
    userEmail: entryParams.ue, // 客户邮箱
    memberId: entryParams.m, // 客户ID
    userMobile: entryParams.um, // 客户手机
    languageCode: entryParams.languageCode?.split('-')[0] || navigator.language?.split('-')[0],
    showToagentFlag: '1', //默认未配置的情况不考虑人工时间
    region: '', // aws区域
    apiGateway: '', // apiGateway地址
    instanceId: '', // connect实例ID
    contactFlowId: '', // connect联系流ID
    chatLanguage: '', // 语言

    chatIconOpen: '', // 聊天组件按钮-展开
    chatIconClose: '', // 聊天组件按钮-关闭

    chatThemeColor: '', // 主题颜色编码
    chatCompanyLogo: '', // 公司logo
    chatTitle: '', // 标题文案
    chatFormIcon: '', // 表单图标
    chatSubmit: '', // 表单提交按钮文案

    chatServiceColor: '', // 聊天消息框底色编码-坐席
    chatMessageColor: '', // 聊天消息框底色编码-客户
    endOfConversation: '', // 结束聊天文案

    // 表单页字段
    preChatForm: {
      visible: true, // 是否可见
      inputFields: [], // 表单输入框列表
    },
  };

  let fieldType1Array = configData.paramList.filter((i) => i.fieldType === 1);
  // 系统字段
  fieldType1Array.forEach((item) => {
    let code = item.code;

    switch (code) {
      case 'chat_region':
        options.region = item.name;
        break;
      case 'chat_api_gateway':
        options.apiGateway = item.name;
        break;
      case 'chat_connect_instance_id':
        options.instanceId = item.name;
        break;
      case 'chat_connect_contact_flow_id':
        options.contactFlowId = item.name;
        break;
      case 'chat_language':
        options.chatLanguage = item.name;
        break;
      case 'chat_theme_color':
        options.chatThemeColor = item.name;
        break;
      case 'chat_icon_open':
        options.chatIconOpen = item.name;
        break;
      case 'chat_icon_close':
        options.chatIconClose = item.name;
        break;
      case 'chat_company_logo':
        options.chatCompanyLogo = item.name;
        break;
      case 'chat_title':
        options.chatTitle = item.name;
        break;
      case 'chat_form_icon':
        options.chatFormIcon = item.name;
        break;
      case 'chat_submit':
        options.chatSubmit = item.name;
        break;
      case 'chat_service_color':
        options.chatServiceColor = item.name;
        break;
      case 'chat_message_color':
        options.chatMessageColor = item.name;
        break;
      case 'end_of_conversation':
        options.endOfConversation = item.name;
        break;
      case 'open_video_button':
        options.openVideoButton = item.name;
        break;
      case 'video_tips':
        options.videoTips = item.name;
        break;
      case 'video_connecting':
        options.videoConnecting = item.name;
        break;
      case 'video_end':
        options.videoEnd = item.name;
        break;
      case 'mute':
        options.mute = item.name;
        break;
      case 'unmute':
        options.unmute = item.name;
        break;
      case 'start_video':
        options.startVideo = item.name;
        break;
      case 'stop_video':
        options.stopVideo = item.name;
        break;
      case 'bot_name': // 渠道方代理名称（客服名称）
        options.botName = item.name;
        break;
      case 'video_tips_accept':
        options.videoTipsAccept = item.name;
        break;
      case 'video_tips_cancel':
        options.videoTipsCancel = item.name;
        break;
      case 'menu_to_agent_icon': // 转人工图标
        options.menuToAgentIcon = item.name;
        break;
      case 'menu_to_agent_txt': // 转人工文案
        options.menuToAgentTxt = item.name || '';
        break;
      case 'chat_welcome_content': // 消息欢迎语
        options.chatWelcomeContent = item.name;
        break;
      case 'video_api_gateway': // 视频apigateway
        options.videoApiGateway = item.name;
        break;
      case 'open_video': // 是否开启视频功能
        options.openVideo = item.name;
        break;
      case 'open_audio': // 是否开启视频功能
        options.openAudio = item.name;
        break;
      case 'chat_connect_video_contact_flow_id': // 视频联系流
        options.chatConnectVideoContactFlowId = item.name;
        break;
      case 'open_knowledge_welcome': // 是否使用配置中的欢迎语，1使用，其他不使用
        options.openKnowledgeWelcome = item.name;
        break;
      case 'knowledge_welcome_q_id': // 欢迎qid
        options.knowledgeWelcomeQId = item.name;
        break;
      case 'chat_form_visible': //是否显示表单
        // 判断是否开启表单
        options.chatFormVisible = item.name === '1';
        // 如果设置了开启表单，则判断是否传了memberId,传了就不展示form
        if (options.chatFormVisible) {
          if (options.memberId) {
            options.chatFormVisible = false;
          } else if (entryParams.localForm) {
            options.chatFormVisible = false;
          }
        }
        break;
      case 'chat_automatic_wake_interval': //自动唤起时间
        options.chatAutomaticWakeInterval = item.name;
        break;
      case 'chat_open_channel_type': //开启聊天类型，0knowledge机器人和connect人工，1仅knowledge机器人，2仅connect人工
        options.chatOpenChannelType = item.name;
        break;
      case 'knowledge_unknown_reply': //机器人未知问题答复文案
        options.chatKnowledgeUnknownReply = item.name;
        break;
      case 'knowledge_unknown_transfer_agent': //是否开启机器人未知问题转人工
        options.chatKnowledgeUnknownTransferAgent = item.name;
        break;
      case 'chat_invite_proactively_flag': //是否开启自动唤起窗口功能
        options.chatInviteProactivelyFlag = item.name;
        break;
      case 'chat_satisfaction_evaluation_flag': //是否开启满意度评价功能
        options.chatSatisfactionEvaluationFlag = item.name;
        break;
      case 'satisfaction_evaluation_message': // 满意度评价消息中的文案
        options.satisfactionEvaluationMessage = item.name;
        break;
      case 'satisfaction_evaluation_tips': // 满意度评价操作区域中的文案
        options.satisfactionEvaluationTips = item.name;
        break;
      case 'close_chat_button': // 关闭窗口按钮文案
        options.closeChatButton = item.name;
        break;
      case 'wait_in_line_before': // 排队人数文案前半段
        options.waitInLineBefore = item.name;
        break;
      case 'wait_in_line_later': // 排队人数文案后半段
        options.waitInLineLater = item.name;
        break;
      case 'message_read': // 客户消息已读
        options.messageRead = item.name;
        break;
      case 'message_sending': // 客户消息发送中
        options.messageSending = item.name;
        break;
      case 'message_delivered': // 客户消息已送达
        options.messageDelivered = item.name;
        break;
      case 'end_chat_message': // 聊天结束的提示
        options.endChatMessage = item.name;
        break;
      case 'join_chat_message': // 加入聊天的提示
        options.joinChatMessage = item.name;
        break;
      case 'user_anonymous_name': // 客户匿名
        let name = entryParams.un || item.name;
        options.username = name;
        break;
      case 'video_overturn': // app视频翻转按钮
        options.videoOverturn = item.name;
        break;
      case 'chat_mobile_upload': // 手机端上传图片按钮文字
        options.chatMobileUpload = item.name;
        break;
      case 'pop_welcome_msg': // 邀请页的文案
        options.popWelcomeMsg = item.name;
        break;
      case 'homepage_welcome_msg':
        options.homepageWelcomeMsg = item.name;
        break;
      case 'homepage_chat_title':
        options.homepageChatTitle = item.name;
        break;
      case 'homepage_chat_subtitle':
        options.homepageChatSubtitle = item.name;
        break;
      case 'homepage_recent_session':
        options.homepageRecentSession = item.name;
        break;
      case 'homepage_other_contact':
        options.homepageOtherContact = item.name;
        break;
      case 'whatsapp_qrcode_contact_msg':
        options.whatsappQrcodeContactMsg = item.name;
        break;
      case 'whatsapp_open_msg':
        options.whatsappOpenMsg = item.name;
        break;
      case 'whatsapp_contact_msg':
        options.whatsappContactMsg = item.name;
        break;
      case 'bot_be_replying_msg':
        options.botBeReplyingMsg = item.name;
        break;
      case 'history_msg_back':
        options.historyMsgBack = item.name;
        break;
      case 'create_new_chat_msg':
        options.createNewChatMsg = item.name;
        break;
      case 'open_email_subscribe_flag':
        options.openEmailSubscribeFlag = item.name;
        break;
      case 'relation_email_address':
        if (item.name) {
          options.relationEmailAddress = item.name;
        }
        break;
      case 'open_whatsapp_subscribe_flag':
        options.openWhatsappSubscribeFlag = item.name;
        break;
      case 'relation_whatsapp_phonenumber':
        if (item.name) {
          options.relationWhatsappPhonenumber = item.name.replace('+', '');
        }
        break;
      case 'document_knowledge_base_id':
        options.documentKnowledgeBaseId = item.name;
        break;
      case 'open_self_chat':
        options.openSelfChat = item.name || '0';
        break;
      case 'hold_to_speak':
        options.holdToSpeak = item.name || '';
        break;
      case 'audio_send_move_cancel':
        options.audioSendMoveCancel = item.name || '';
        break;
      case 'no_recording_permission':
        options.noRecordingPermission = item.name;
        break;
      case 'slide_up_to_cancel':
        options.slideUpToCancel = item.name;
        break;
      case 'cancel_sent':
        options.cancelSent = item.name;
        break;
      case 'no_text_detected':
        options.noTextDetected = item.name;
        break;
      case 'show_toagent_flag': // 是否显示转人工按钮
        options.showToagentFlag = item.name;
        break;
      case 'chat_robot_icon': // 机器人/坐席头像
        options.chatRobotIcon = item.name;
        break;
      case 'chat_user_icon': // 客户头像
        options.chatUserIcon = item.name;
        break;
      case 'no_available_agent': // 无坐席在线的文案
        options.noAvailableAgent = item.name;
        break;
      case 'show_history_chat_flag': // 历史记录是否展示，1-开启，0-不开启
        options.showHistoryChatFlag = item.name;
        break;
      case 'history_chat_num': // 历史记录展示条数
        options.historyChatNum = item.name;
        break;
      case 'agent_not_worktime_reply': //人工服务不在时间内回复
        options.notWorkTime = item.name;
        break;
      case 'chat_agent_font_color':
        options.agentFontColor = item.name;
        break;
      case 'chat_user_font_color':
        options.userFontColor = item.name;
        break;
      case 'retry_info':
        options.retryInfo = item.name;
        break;
      case 'reassign_join':
        options.reassignJoin = item.name;
        break;
      case 'be_typing': //正在输入
        options.beTyping = item.name;
        break;
      case 'recall_msg': //撤回消息
        options.recallMsg = item.name;
        break;
      case 'is_recall_msg': // 已撤回消息
        options.isRecallMsg = item.name;
        break;
      case 'enable_app_voice_input':
        options.enableAppVoiceInput = item.name;
        break;
      case 'push_system_message_flag':
        options.pushSystemMessageFlag = item.name;
        break;
      case 'is_show_form_field_phone': // 是否现实表单中的手机号字段。0不显示，反之都显示。
        options.isShowFormFieldPhone = item.name;
        break;
      case 'file_size_error_text': // 文件大小错误提示文案
        options.fileSizeErrorText = item.name;
        break;
      case 'file_size_error_button': // 文件大小错误提示按钮文案
        options.fileSizeErrorButton = item.name;
        break;
      case 'doc_bot_flag': //是否开启文档知识库
        options.docBotFlag = item.name;
        break;
    }
  });
  if (options.botBeReplyingMsg) {
    options.botBeReplyingMsg = options.botBeReplyingMsg.replace('{botName}', options.botName || '');
  }

  // let fieldType3Array = configData.paramList.filter((i) => i.fieldType === 3);
  // 定义需要控制的字段配置映射
  const fieldVisibilityConfig = {
    chat_phone_number: options.isShowFormFieldPhone,
    // 可以添加其他字段配置，例如：
    // 'chat_user_name': options.isShowFormFieldUserName,
    // 'chat_email': options.isShowFormFieldEmail
  };
  let fieldType3Array = configData.paramList.filter(
    (item) => item.fieldType === 3 && !(fieldVisibilityConfig[item.code] === '0')
  );
  // 表单字段
  if (fieldType3Array.length === 0) {
    // 不显示表单页面
    options.preChatForm.visible = options.chatFormVisible === undefined ? false : options.chatFormVisible;
    options.preChatForm.inputFields = [];
  } else {
    // 显示表单页面
    options.preChatForm.visible = options.chatFormVisible === undefined ? false : options.chatFormVisible;

    options.preChatForm.inputFields[0] = {};
    options.preChatForm.inputFields[1] = {};

    fieldType3Array.forEach((item) => {
      let field = {
        code: item.code,
        name: item.name,
        type: 'text',
        validation: 'required',
      };
      if (item.code === 'chat_user_name') {
        options.preChatForm.inputFields[0] = field;
      } else if (item.code === 'chat_email') {
        field.validation =
          /^[a-zA0-9_.-]+@[a-z0-9-]+(.[a-z]+)*.(com|cn|net|hk|tw|de|fr|jp|lk|in|nz|ru|sg|il|fm|zm|ar|mk|gn|mx|fr|zw|ci|na|np|mn|to|om|za|sa|se|gr|all|au|at|qa|my|kr|pk|ae|vn|es|it|id|uk|pl|xyz|ltd|group|wang|club|work|gold|cool|life|art|love|world|asia|cc|biz|games|sale|media|fit|studio|fyi|cab|market|news|vin|tax|shopping|mba|cash|cafe|technology|co|fans|ren|cloud|shop|law|link|show|info|mobi|tv|top|vip|beer|fashion|luxe|online|chat|pub|run|city|live|pro|red|pet|kim|blue|ski|pink|space|host|fun|site|store|yoga|website|band|voto|archi|vote|promo|poker|organic|lotto|green|black|bio|social|zone|email|today|team|guru|fund|center|plus|video|wiki|design|company|icu|press|me|cf|ai|ink|la|ru|sarl|rs|rip|gd|pl)$/i;
        options.preChatForm.inputFields[1] = field;
      } else if (item.code === 'chat_phone_number') {
        options.preChatForm.inputFields[2] = {};
        field.validation = /^(?:\+\d{4,17}|\d{5,18})$/;
        options.preChatForm.inputFields[2] = field;
      } else {
        options.preChatForm.inputFields.push(field);
      }
    });
  }

  return options;
}

/**
 * 创建DOM
 * @param containerId id
 */
function createDomNode(containerId) {
  /*let newDiv = document.createElement('div');
  newDiv.id = containerId;
  newDiv.style.cssText = 'margin: 0; font-family: sans-serif !important;';
  let body = document.getElementsByTagName('body')[0];
  body.appendChild(newDiv);*/

  // 获取页面元素中第一个id为ConnectNowChat的div元素。
  let connectNowChatDiv = document.getElementById(containerId);

  // 判断是否这个元素是存在，如果不存在则创建新的div元素id为ConnectNowChat
  if (!connectNowChatDiv) {
    connectNowChatDiv = document.createElement('div');
    connectNowChatDiv.id = containerId;
  }

  connectNowChatDiv.style.cssText = 'margin: 0;';
  // 将这个div元素添加到body节点中。这样做是为了保证body中只有一个id为ConnectNowChat的div
  document.body.appendChild(connectNowChatDiv);
}

/**
 * 获取设备类型
 *
 * @returns string 移动端返回mobile，网页端返回pc
 */
function getDevice() {
  const userAgent = window.navigator.userAgent; // 获取User Agent信息
  let isMobileDevice = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    isMobileDevice = true; // 如果包含上述关键字之一，则认为是移动端
  } else if (/(Windows Phone)/i.test(userAgent) || /(Macintosh)/i.test(userAgent)) {
    isMobileDevice = false; // 否则认为是PC端
  }

  return isMobileDevice ? 'mobile' : 'pc';
}
function loadChatCss() {
  // 创建一个新的 link 标签
  let link = document.createElement('link');

  // 设置 rel 属性为 stylesheet
  link.rel = 'stylesheet';

  // 设置 href 属性为 umi.css 文件的URL
  /*let env = process.env.UMI_ENV;
  if (env === 'development') {
    // localhost使用
    // link.href = '../src/lib/umi.css';

    // 测试环境-s3桶名：287316796928上的goclouds-connectNow-chat-test
    link.href = 'https://d1362bz2rn3chi.cloudfront.net/umi.css';
  } else if (env === 'production') {
    // 生产环境-文件在香港account上的s3中
    // link.href = 'https://chat.connectnow.cn/umi.css';
    link.href = "https://"+process.env.API_HOST+"/umi.css";
  } else {
    link.href = "https://"+process.env.API_HOST+"/sg-chat/umi.css";
  }*/
  link.href = process.env.CSS_RESOURCES;

  // 将 link 标签添加到文档的 head 部分
  document.head.appendChild(link);
}
